<template>
  <div>{{ model }}</div>
</template>

<script>
export default {
  name: "double",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
